import { SAVE_WISHLIST_ITEMS, SAVE_WISHLIST_ITEMS_COUNT } from '../actionTypes';

const initialState = {
  wishlistItemCount: 0,
  data: [],
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_WISHLIST_ITEMS:
      return {
        ...state,
        data: action.data,
      };
    case SAVE_WISHLIST_ITEMS_COUNT:
      return {
        ...state,
        wishlistItemCount: action.data,
      };
    default:
      return state;
  }
};

export default wishlistReducer;
